/**
 * Route for `campaign-fallback`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignFallbackPage } from "../features/campaign-fallback/CampaignFallbackPage";

export const campaignFallbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-fallback",
	component: CampaignFallbackPage,
});

export default campaignFallbackRoute;
